export function toUserId(value: unknown): number {
	return Number(value);
}

export function isSameUserId(left: unknown, right: unknown): boolean {
	return toUserId(left) === toUserId(right);
}
